import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  // Handle scroll events to change navbar appearance
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu and scroll to top when changing routes
  useEffect(() => {
    setIsMenuOpen(false);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [location.pathname]);

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Toggle body class for preventing scroll when menu is open
    if (!isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  };

  // Function to handle link clicks - ensures scrolling to top
  const handleLinkClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    // Close menu if open
    if (isMenuOpen) {
      setIsMenuOpen(false);
      document.body.classList.remove('menu-open');
    }
  };

  return (
    <header className={`navbar ${isScrolled ? 'scrolled' : ''} ${isMenuOpen ? 'menu-open' : ''}`}>
      <div className="navbar-container">
        <div className="logo">
          <Link to="/" onClick={handleLinkClick}>
            <div className="logo-content">
              <img src="/logo512.png" alt="Adelphi Finance Club Logo" className="club-logo" />
              <h1>Adelphi University Finance Club</h1>
            </div>
          </Link>
        </div>
        
        <button 
          className="mobile-menu-button" 
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <span className="hamburger-icon">
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </span>
        </button>
        
        <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            <li>
              <Link to="/" className={location.pathname === '/' ? 'active' : ''} onClick={handleLinkClick}>
                <span className="nav-icon home-icon"></span>
                <span className="nav-text">Home</span>
              </Link>
            </li>
            <li>
              <Link to="/events" className={location.pathname === '/events' ? 'active' : ''} onClick={handleLinkClick}>
                <span className="nav-icon events-icon"></span>
                <span className="nav-text">Events</span>
              </Link>
            </li>
            <li>
              <Link to="/news" className={location.pathname === '/news' ? 'active' : ''} onClick={handleLinkClick}>
                <span className="nav-icon news-icon"></span>
                <span className="nav-text">News</span>
              </Link>
            </li>
            <li>
              <Link to="/members" className={location.pathname === '/members' ? 'active' : ''} onClick={handleLinkClick}>
                <span className="nav-icon members-icon"></span>
                <span className="nav-text">Members</span>
              </Link>
            </li>
            <li>
              <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''} onClick={handleLinkClick}>
                <span className="nav-icon contact-icon"></span>
                <span className="nav-text">Contact</span>
              </Link>
            </li>
          </ul>
          <div className="nav-cta">
            <a href="https://myaulife.adelphi.edu/organization/financeclub/" 
               target="_blank" 
               rel="noopener noreferrer"
               className="join-button">
              Join Now
            </a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;